import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiService {
 private baseUrl = environment.apiBaseUrl;
  private menuUrl = 'assets/fakedb/menu.json'; 
  constructor(private http: HttpClient) { }

  // Fetch the menu data from the JSON file or API
  getMenuData(): Observable<any> {
    return this.http.get<any>(this.menuUrl);
  }

  post(endpoint: string, data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/${endpoint}`, data);
  }

  get<T>(endpoint: string): Observable<T> {
    return this.http.get<T>(`${this.baseUrl}/${endpoint}`);
  }

  put(endpoint: string, data: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/${endpoint}`, data);
  }

  patch(endpoint: string, data: any,): Observable<any> {
    return this.http.patch(`${this.baseUrl}/${endpoint}`, data);
  }
  delete(endpoint: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${endpoint}`);
  }
}
